import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ValidatedLegacyDateSetting } from '@bingads-webui-campaign/date-setting';
import { ValidatedLegacyAdSchedule } from '@bingads-webui-campaign/ad-schedule';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const AdSchedule = ({
  adGroup,
  campaign,
  isCreate,
  hideUseCampaignSetting,
  showBidAdjustmentColumn,
  setAdScheduleViewCallback,
  isDateSettingsDisplayed,
}) => {
  const i18n = useContext(I18nContext);

  const {
    adSchedules,
    StartDate,
    EndDate,
    deal,
  } = adGroup || {};

  const {
    adSchedules: campaignAdSchedules = {},
    TimeZone,
  } = campaign || {};

  return (
    <>
      {
        isDateSettingsDisplayed &&
        <ValidatedLegacyDateSetting
          i18n={i18n}
          validationProps={{
            data: {
              StartDate,
              EndDate,
              TimeZone,
              isCreate,
            },
          }}
        />
      }
      {
        !deal &&
        <ValidatedLegacyAdSchedule
          isCreation
          hideMinuteOptions
          level="adgroup"
          entity={{ data: adGroup }}
          validationProps={{
            data: adSchedules,
          }}
          setAdScheduleView={setAdScheduleViewCallback}
          showBidAdjustmentColumn={showBidAdjustmentColumn}
          campaignDayTimeRanges={campaignAdSchedules.dayTimeRanges}
          hideUseCampaignSetting={hideUseCampaignSetting}
        />
      }
    </>
  );
};

AdSchedule.propTypes = {
  adGroup: PropTypes.shape({}),
  campaign: PropTypes.shape({}),
  isCreate: PropTypes.bool,
  hideUseCampaignSetting: PropTypes.bool,
  showBidAdjustmentColumn: PropTypes.bool,
  setAdScheduleViewCallback: PropTypes.func,
  isDateSettingsDisplayed: PropTypes.bool,
};

AdSchedule.defaultProps = {
  adGroup: {},
  campaign: {},
  isCreate: undefined,
  hideUseCampaignSetting: false,
  showBidAdjustmentColumn: false,
  setAdScheduleViewCallback: () => { },
  isDateSettingsDisplayed: true,
};
